var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "usersList" } },
    [
      _c(
        "v-overlay",
        { staticClass: "waitoverlay", attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            staticClass: "mr-4",
            attrs: { indeterminate: "", size: "64" }
          }),
          _vm._v(" " + _vm._s(_vm.waitMessage) + " ")
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "8", md: "6" } }, [
                    _vm._v(" " + _vm._s(_vm.title) + " "),
                    _vm.isSeatLimit && !_vm.loading
                      ? _c("span", { staticClass: "sm" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("users.list.seats-remain", [
                                _vm.seatsRemaining
                              ])
                            )
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-sm-right",
                      attrs: { cols: "12", sm: "4", md: "6" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", disabled: _vm.quotaFull },
                          on: { click: _vm.createItemDialog }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("users.add-user")) + " ")]
                      ),
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            color: "secondary",
                                            "aria-label": _vm.$t("users.menu")
                                          },
                                          on: { click: _vm.focusFirstItem }
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c("v-icon", {}, [_vm._v(" mdi-menu ")])],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                { ref: "firstItem", attrs: { tabindex: "0" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "secondary",
                                        text: true,
                                        block: ""
                                      },
                                      on: { click: _vm.confirmInviteAll }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("users.send-invitations")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { attrs: { tabindex: "0" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        block: true,
                                        color: "secondary",
                                        text: true
                                      },
                                      on: { click: _vm.exportData }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("export-users")) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { attrs: { tabindex: "0" } },
                                [
                                  _vm.csvimport
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: true,
                                            text: true,
                                            disabled: _vm.quotaFull,
                                            color: "secondary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push(
                                                "/admin/users/import"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("users.import-users")
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { attrs: { tabindex: "0" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        block: true,
                                        text: true,
                                        disabled: _vm.selected.length === 0,
                                        color: "secondary"
                                      },
                                      on: { click: _vm.validateDeleteSelection }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("delete-selected-users", [
                                              _vm.selected.length > 0
                                                ? "(" +
                                                  _vm.selected.length +
                                                  ")"
                                                : ""
                                            ])
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm.userHasResetLinkPermission
                                ? _c(
                                    "v-list-item",
                                    { attrs: { tabindex: "0" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: true,
                                            text: true,
                                            color: "secondary"
                                          },
                                          on: {
                                            click: _vm.generateResetPasswordLink
                                          }
                                        },
                                        [_vm._v(" Generate reset link ")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            { attrs: { width: "100%" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: _vm.$t("global.search"),
                          "aria-label":
                            _vm.$t("global.text-field") +
                            " " +
                            _vm.$t("global.search") +
                            " " +
                            _vm.$t("users.users"),
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex align-center",
                      attrs: { cols: "12", sm: "6", md: "8" }
                    },
                    [
                      _vm.dateFilterActive
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "mr-2 datepicker",
                              attrs: {
                                close: "",
                                color: "primary",
                                outlined: ""
                              },
                              on: { "click:close": _vm.clearDateFilter }
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v(" mdi-calendar-range ")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatDateRange(
                                      _vm.startDate,
                                      _vm.endDate
                                    )
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "auto"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            small: "",
                                            color: "secondary"
                                          }
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v(" mdi-calendar-filter ")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "users.header.filter-by-date"
                                            )
                                          ) +
                                          " "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.dateMenu,
                            callback: function($$v) {
                              _vm.dateMenu = $$v
                            },
                            expression: "dateMenu"
                          }
                        },
                        [
                          _c(
                            "v-date-picker",
                            {
                              attrs: {
                                range: "",
                                "no-title": "",
                                scrollable: ""
                              },
                              on: { "click:date": _vm.onDateClick },
                              model: {
                                value: _vm.tempDates,
                                callback: function($$v) {
                                  _vm.tempDates = $$v
                                },
                                expression: "tempDates"
                              }
                            },
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "" },
                                  on: { click: _vm.cancelDateFilter }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("global.cancel")) + " "
                                  )
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "primary" },
                                  on: { click: _vm.applyDateFilter }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("global.confirm")) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.computedHeaders.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  items: _vm.filteredItems,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search,
                  "show-select": "",
                  "items-per-page": 30,
                  "footer-props": {
                    "items-per-page-options": [15, 30, 50, 100, -1]
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.displayName",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm.userlinks
                          ? _c("a", { attrs: { href: _vm.createURL(item) } }, [
                              _vm._v(" " + _vm._s(item.displayName) + " ")
                            ])
                          : _vm._e(),
                        !_vm.userlinks
                          ? _c("span", [_vm._v(_vm._s(item.displayName))])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.roles",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("v-chip", { class: _vm.getHighestRoleOf(item) }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("role." + _vm.getHighestRoleOf(item))
                              ) +
                              " "
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.status",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(" " + _vm._s(_vm.statusText(item.status)) + " ")
                      ]
                    }
                  },
                  {
                    key: "item.createdAt",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(item.createdAt)) + " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _vm.hasEditPermissions(item)
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  "aria-label":
                                                    _vm.$t("global.edit") +
                                                    " " +
                                                    _vm.$t("users.userParam", [
                                                      item.displayName
                                                    ])
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editItem(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-pencil-outline ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("edit")))])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      item.id !==
                                        _vm.$store.getters.currentUserProfile
                                          .user.id &&
                                      _vm.hasEditPermissions(item) &&
                                      _vm.hasDeletePermissions(item)
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  "aria-label":
                                                    _vm.$t("global.delete") +
                                                    " " +
                                                    _vm.$t("users.userParam", [
                                                      item.displayName
                                                    ])
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteItem(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-delete-outline ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      item.status !== "registered" &&
                                      item.status !== "invited" &&
                                      item.email
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  "aria-label": _vm.$t(
                                                    "users.invite",
                                                    [item.displayName]
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.inviteUser(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-email-outline ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("invite-unregistered")))
                            ])
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      item.status == "invited"
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  "aria-label": _vm.$t(
                                                    "users.inviteAgain",
                                                    [item.displayName]
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.inviteUser(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " mdi-email-multiple-outline "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("invite")))])]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.showEditDialog,
                callback: function($$v) {
                  _vm.showEditDialog = $$v
                },
                expression: "showEditDialog"
              }
            },
            [
              _c("user-edit", {
                attrs: {
                  model: _vm.editedItem,
                  roles: _vm.roles,
                  "content-selection": _vm.content
                },
                on: { cancel: _vm.closeEditDialog, save: _vm.saveEditDialog }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showDeleteDenied,
                callback: function($$v) {
                  _vm.showDeleteDenied = $$v
                },
                expression: "showDeleteDenied"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("users.cant-delete-user"))),
                    _c("br")
                  ]),
                  _c("v-card-text", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("users.cant-delete-user-content", [
                            _vm.editedItem.displayName
                          ])
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1" },
                          on: {
                            click: function($event) {
                              _vm.showDeleteDenied = false
                            }
                          }
                        },
                        [_vm._v(" OK ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showDeleteDialog,
                callback: function($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("users.confirm-delete", [
                          _vm.editedItem.displayName
                        ])
                      )
                    ),
                    _c("br")
                  ]),
                  _c("v-card-text", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("users.list.delete-warning"))
                    }
                  }),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c("v-btn", { on: { click: _vm.closeDeleteDialog } }, [
                        _vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.confirm")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showErrorDialog,
                callback: function($$v) {
                  _vm.showErrorDialog = $$v
                },
                expression: "showErrorDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(_vm._s(_vm.$t("global.error")))]),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$t("users.error-message"))),
                    _c("br"),
                    _vm._v('"' + _vm._s(_vm.error) + '"')
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1" },
                          on: { click: _vm.closeErrorDialog }
                        },
                        [_vm._v(" OK ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.inviteAllDialogVisible,
                callback: function($$v) {
                  _vm.inviteAllDialogVisible = $$v
                },
                expression: "inviteAllDialogVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("users.confirm-delete", [
                          _vm.editedItem.displayName
                        ])
                      )
                    ),
                    _c("br")
                  ]),
                  _c("v-card-text", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("users.list.delete-warning"))
                    }
                  }),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c("v-btn", { on: { click: _vm.closeDeleteDialog } }, [
                        _vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.confirm")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showErrorDialog,
                callback: function($$v) {
                  _vm.showErrorDialog = $$v
                },
                expression: "showErrorDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(_vm._s(_vm.$t("global.error")))]),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$t("users.error-message"))),
                    _c("br"),
                    _vm._v('"' + _vm._s(_vm.error) + '"')
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1" },
                          on: { click: _vm.closeErrorDialog }
                        },
                        [_vm._v(" OK ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.inviteAllDialogVisible,
                callback: function($$v) {
                  _vm.inviteAllDialogVisible = $$v
                },
                expression: "inviteAllDialogVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("users.bulk-user-invitations")))
                  ]),
                  _c("v-card-text", [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("users.confirm-invite"))
                      }
                    })
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary" },
                          on: { click: _vm.cancelInviteAll }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.inviteAll(true)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("users.uninvited")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: {
                            click: function($event) {
                              return _vm.inviteAll(false)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("users.all")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.resetPasswordLinkDialogVisible,
                callback: function($$v) {
                  _vm.resetPasswordLinkDialogVisible = $$v
                },
                expression: "resetPasswordLinkDialogVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v("Generate rest password link")]),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("user-email"),
                              rules: [_vm.rules.emailRules],
                              required: ""
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _c(
                            "a",
                            {
                              style: _vm.styleForTag,
                              attrs: { href: _vm.link }
                            },
                            [_vm._v(" " + _vm._s(_vm.link) + " ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary" },
                              on: { click: _vm.cancelGenerationResetPassword }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.cancel")) + " "
                              )
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", disabled: !_vm.valid },
                              on: { click: _vm.generationResetPasswordLink }
                            },
                            [_vm._v(" Generate ")]
                          ),
                          _c("v-spacer")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "700px" },
              model: {
                value: _vm.showDeleteSelectedConfirm,
                callback: function($$v) {
                  _vm.showDeleteSelectedConfirm = $$v
                },
                expression: "showDeleteSelectedConfirm"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("deleted-selected-users-title")))
                  ]),
                  _c("v-card-text", [
                    _vm.selected.length === 0
                      ? _c("p", {
                          staticClass: "text-center",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "users.confirm-selected-users-if-no-user-selected"
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm.selected.length > 0
                      ? _c("p", {
                          staticClass: "text-center",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("users.confirm-selected-users", [
                                _vm.selected.length
                              ])
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm.selected.length > 0
                    ? _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary" },
                              on: {
                                click: function($event) {
                                  _vm.showDeleteSelectedConfirm = false
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.cancel")) + " "
                              )
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "error" },
                              on: { click: _vm.deleteUserSelection }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.confirm")) + " "
                              )
                            ]
                          ),
                          _c("v-spacer")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }